// extracted by mini-css-extract-plugin
export default {"modal":"CreateTemplateModal-module__modal__Bsug9","content":"CreateTemplateModal-module__content__lnqCj"};